import { dayjs } from '@shared/utils';

import { getAvailableYears } from './get-available-years';

export const PAST_YEAR_LIMIT = 5;

export function formatYear(year: number) {
  return dayjs().year(year).format('BBBB');
}

function getAvailableYearsForFilter() {
  const currentYear = new Date().getFullYear();
  return getAvailableYears(currentYear, PAST_YEAR_LIMIT);
}

export const AVAILABLE_YEARS_OPTIONS = getAvailableYearsForFilter().map((year) => ({
  label: formatYear(year),
  value: year,
}));
